import {useState, useEffect} from "react";

import PropTypes from "prop-types";

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Icon from "@mui/material/Icon";
import backgroundImage from "assets/images/BNT.jpg";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";

import breakpoints from "assets/theme/base/breakpoints";

// Images
import dj from "assets/images/team-5.jpg";
import {Typography} from "@mui/material";
import properties from "constants/ApplicationConstants";
import {formatDesignation} from "constants/ApplicationConstants";

function Header({userData, children}) {
  const [tabsOrientation, setTabsOrientation] = useState("horizontal");
  const [tabValue, setTabValue] = useState(0);

  useEffect(() => {
    function handleTabsOrientation() {
      return window.innerWidth < breakpoints.values.sm
        ? setTabsOrientation("vertical")
        : setTabsOrientation("horizontal");
    }

    /** 
     The event listener that's calling the handleTabsOrientation function when resizing the window.
    */
    window.addEventListener("resize", handleTabsOrientation);

    // Call the handleTabsOrientation function to set the state with the initial value.
    handleTabsOrientation();

    return () => window.removeEventListener("resize", handleTabsOrientation);
  }, [tabsOrientation]);

  const handleSetTabValue = (event, newValue) => setTabValue(newValue);

  const photo = userData?.photo
    ? userData.photo.startsWith("/")
      ? `data:image/jpeg;base64,${userData?.photo}`
      : `data:image/jpeg;base64,${userData?.photo}`
    : null;

  return (
    <MDBox position="relative" mb={3} mt={0} mx={0}>
      <MDBox
        display="flex"
        alignItems="center"
        position="relative"
        minHeight="20.75rem"
        borderRadius="xl"
        sx={{
          backgroundImage: ({functions: {rgba, linearGradient}, palette: {gradients}}) =>
            `url(${backgroundImage})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "98% 66%",
          backgroundPosition: "center",
          mt: -5,
          mx: 0
        }}
      />
      <Card
        sx={{
          position: "relative",
          mt: -7,
          mx: 1,
          py: 2,
          px: 2
        }}
      >
        <Grid container spacing={3} alignItems="center">
          <Grid item>
            <MDAvatar src={photo} alt="profile-image" size="xl" shadow="sm" />
          </Grid>
          <Grid item>
            <MDBox height="100%" mt={0.5} lineHeight={1}>
              <Typography variant="h5" fontWeight="bold" fontFamily={properties.fontFamily}>
                {userData?.firstName} {userData?.lastName}
              </Typography>
              <MDTypography variant="button" color="text" fontWeight="regular">
                {formatDesignation(userData?.designation)}
              </MDTypography>
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={4} sx={{ml: "auto"}}>
            <AppBar position="static">
              {/* <Tabs orientation={tabsOrientation} value={tabValue} onChange={handleSetTabValue}>
                <Tab
                  label="App"
                  icon={
                    <Icon fontSize="small" sx={{ mt: -0.25 }}>
                      home
                    </Icon>
                  }
                />
                <Tab
                  label="Message"
                  icon={
                    <Icon fontSize="small" sx={{ mt: -0.25 }}>
                      email
                    </Icon>
                  }
                />
                <Tab
                  label="Settings"
                  icon={
                    <Icon fontSize="small" sx={{ mt: -0.25 }}>
                      settings
                    </Icon>
                  }
                />
              </Tabs> */}
            </AppBar>
          </Grid>
        </Grid>
        {children}
      </Card>
    </MDBox>
  );
}

// Setting default props for the Header
Header.defaultProps = {
  children: ""
};

// Typechecking props for the Header
Header.propTypes = {
  children: PropTypes.node
};

export default Header;
